import { MinicartCarouselResults } from 'libs/searchspring/components/recommendations/MinicartCarouselResults'
import { withRecommendationProvider } from 'libs/searchspring/components/recommendations/withRecommendationsProvider'

export const MinicartCarousel = withRecommendationProvider(MinicartCarouselResults)
